import React, { useEffect, useState } from 'react'
import { Card, Col,Row,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import { Api } from '../../../componentes/Api';
import Swal from 'sweetalert2';
import Moment from 'moment'

const modeloDatos = {
    recordID:0,
    empresaID: 0,
    pacienteID: 0
    , seguroID: 0
    , poliza: ''
    , motivoConsulta: ''
    , resultado: ''
    , espec_Vaginal: ''
    , mamas: ''
    , dx: ''
    , plan_A: ''

    , historia: ''
    , comentario: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''
}
export const GinecologiaRecord = ({ data }) => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModalComp, setverModalComp] = useState(false);
    const [ApSeleccion, SetApSeleccion] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const handleChange = (e) => {
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }

    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
      
        let response = await fetch(Api + "Pacientes/listaCRecord/" + correo + "/"+ data.pacienteID);
        if (response.ok) {
            let data1 = await response.json()
            SetListado(data1)
            setPendiente(false)
        }
    }



    useEffect(() => {
        if (data.length != 0) {
          obtenerDatos();  
        }
       
    })
   
    const guardarCambiosComp = async () => {
        let response;
        if (tabla.recordID == 0) {

            tabla.poliza = data.poliza;
            tabla.pacienteID = data.pacienteID;
            tabla.peguroID = data.seguroID;
            tabla.creadoPor = correo;
            tabla.codificadoPor = "1";
            tabla.seguroID = parseInt(data.seguroID);
        


            response = await fetch(Api + "Pacientes/GuardarCRecord", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setverModalComp(!verModalComp);
        } else {
            response = await fetch(Api + "Pacientes/EditarCRecord", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)

            })
            SetApSeleccion(false);
        }

        if (response.ok) {
            setverModalComp(false)
            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setverModalComp(!verModalComp);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setverModalComp(!verModalComp);
            }
        } else {
            alert("error al guardar")
        }

    }
    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
            }
        })

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarComponente/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const nuevocomponente = (d, t) => {
    
        setTabla(tabla);
        setverModalComp(!verModalComp);
      
    }
    const abrirEditarModal = (data) => {
        setTabla(data);
        setverModalComp(!verModalComp);
        SetApSeleccion(!ApSeleccion);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        SetApSeleccion(false);
        setverModalComp(false)
    }

    const columns = [
        {
            name: 'Fecha',
            selector: row => Moment(row.fechaCreado).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Motivo Consulta ',
            selector: row => row.motivoConsulta,
            sortable: true,
        },
        {
            name: 'Resultado ',
            selector: row => row.resultado,
            sortable: true,
        },
        //{
        //    name: 'Version',
        //    selector: row => row.versionID,
        //    sortable: true,
        //},

        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {

        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,

            },
        },
        headRow: {
            style: {
                backgroundColor: "#ffff",
            }
        },
        cells: {
            style: {
                backgroundColor: "#eee !important",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por p�gina',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };


    return (
        <>

           
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    <h5> Estas Visualizando los record del paciente <b>{data.nombres}</b> </h5>
                    
                  

                </CardHeader>
                <CardBody>

                    <Button color="success" size="sm"
                        onClick={() => nuevocomponente(data.nivelID, data.texto)}
                    > Agregar nueva Consulta
                        <i className="fas fa-pluss"></i>
                    </Button>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        customStyles={customStyles}

                    />
                </CardBody>
            </Card>


            <Modal isOpen={verModalComp}>
                <ModalHeader>
                    Mantenimiento de Consulta 
                </ModalHeader>
                <ModalBody>
                    <Row>
                   

                        <Col md="6">
                            <FormGroup>
                                                       <Label for="exampleEmail">MotivoConsulta</Label>
                                <Input type="text" name="motivoConsulta"  value={tabla.motivoConsulta }
                                    placeholder="MotivoConsulta" onChange={handleChange} />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup> <Label for="exampleEmail">Mamas</Label>
                                <Input type="text" name="mamas" value={tabla.mamas}
                                                    placeholder="Mamas" onChange={handleChange}/>
                                                  
                            </FormGroup>
                        </Col>
                                          <Col md="6">   <FormGroup className='T_Record'>
                                             <Label for="exampleEmail">Resultado</Label>
                            <Input type="text" name="resultado"  value={tabla.resultado}
                                                    placeholder="Resultado" onChange={handleChange}/>
                        </FormGroup>  </Col>
                        <Col md="6"><FormGroup>
                                                       <Label for="exampleEmail">Espec_Vaginal</Label>
                            <Input type="text" name="espec_Vaginal" value={tabla.espec_Vaginal}
                                                    placeholder="Espec_Vaginal" onChange={handleChange}/>   
                                            </FormGroup></Col>

                                          

                                                    <Col md="6">  <FormGroup className='T_Record'>
                                                       <Label for="exampleEmail">Dx</Label>
                            <Input type="text" name="dx" value={tabla.dx}
                                placeholder="Dx" onChange={handleChange} />
                        </FormGroup> </Col>  
                        <Col md="6"> <FormGroup> <Label for="exampleEmail">Plan_A</Label>
                            <Input type="text" name="plan_A" value={tabla.plan_A}
                                                    placeholder="Plan_A" onChange={handleChange}/>
                                                   
                                            </FormGroup> </Col>
                    </Row>
                     <Row>
                                          <Col md="12">    <FormGroup className='T_Record'>

                                                  
                                                       <Label for="exampleEmail">Historia</Label>
                            <Input type="textarea" name="historia" value={tabla.historia}
                                                    placeholder="Historia" onChange={handleChange}/>  
                                            </FormGroup> </Col>

                                         <Col md="12">    <FormGroup className='T_Record'>
                                             <Label for="exampleEmail">Comentario</Label>
                            <Input type="textarea" name="comentario" value={tabla.comentario}
                                                    placeholder="Comentario" onChange={handleChange}/>
                                                   

                                            </FormGroup> </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambiosComp}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

//import React, {Fragment,useState} from 'react';
//import {T_Record }from './T_Record';
//import { CSSTransition, TransitionGroup } from 'react-transition-group';
//import axios from 'axios';
//import { Button, Form, FormGroup, Label,  Input, FormText, Row, Col, Card, CardBody,
//    CardTitle,
//} from 'reactstrap';
//import { Apiurl } from '../../../assets/Apirest';


//export default function NuevoRecord (props) {

//    const [Record, setRecord] = useState([T_Record ]);
//    const baseUrl= Apiurl+"Record";

//    //Capturar en Memoria
//const handleChange  =e=>{
//    const {name, value}=e.target;
//    setRecord({
//      ...Record, [name]: value
//    });
//    console.log(Record);
//  }

//  let Canelar=()=>{
   
//    alert(props.in);
//  }

    
//// CODIGO insertar PARA GUARDAR FORMULARIO EN LA DB
//const peticionPost =async() =>{
//    Record.EmpresaID = 1;
//    Record.Poliza = props.D_Paciente.poliza;
//    Record.PacienteID = props.D_Paciente.pacienteID;
//    Record.SeguroID = props.D_Paciente.seguroID;
//    Record.CreadoPor = "1";
//    Record.ModificadoPor = "1";
//    Record.SeguroID = parseInt(Record.SeguroID);
//    Record.fechacreado = new Date;
//    Record.fechamodificado = new Date;

//    if (Record.MotivoConsulta != "" ) 
//    {  await axios.post(baseUrl,Record)
//      .then(response=>{
//        setRecord(Record.concat(response.data));
    
//      //   Notificacion("Guardado");
//      }).catch(error => {console.log(error);
//      })}else{}
//      }

//    //   NotificacionError("Faltan Campos por registrar");
//        return (
//            <Fragment>
//                <TransitionGroup>
//                    <CSSTransition
//                        component="div"
//                        className="TabsAnimation"
//                        appear={true}
//                        timeout={0}
//                        enter={false}
//                        exit={false}>
//                        <div>
//                            <Row>
//                            <Col md="12">
//                                <Card className="main-card mb-3">
//                                    <CardBody>
//                                        <CardTitle>Nuevo Record    </CardTitle>
//                                   {/* {alert(props.D_Paciente.nombres)} */}
//                                        <Form>
//                                          

//                                            <Button color="primary" className="mt-1" onClick={()=>peticionPost()}>Submit</Button>
                                    
//                                            <Button color="primary" className="mt-1" onClick={()=>Canelar()}>Cancelar</Button>
//                                        </Form>
//                                    </CardBody>
//                                </Card>
//                            </Col>
                           
//                        </Row>
                         
//                        </div>
//                    </CSSTransition>
//                </TransitionGroup>
//            </Fragment>
            
//        );
//    }


